import { sanitizeBookTag } from "./bookTag";
import { setBookFormat } from "../services/bookService";
import { updateBook } from "../redux/slice/profileSlice";

/**
 * Printed book or PDF only (docs/design/HANDOFF.md, "PDF-only books go through
 * the cart"). A PDF-only book is tagged `downloadPdf`; it goes through Review
 * order like any book and checks out as the $9.95 PDF product.
 */

export const isPdfBook = (book) => sanitizeBookTag(book?.tag) === "downloadPdf";

/**
 * Never gift books (the API also refuses Etsy books). An ordered book can switch for
 * its next order (Order again); past orders keep the format they were bought in.
 */
export const canSwitchFormat = (book) => !!book && !book?.gift?.giftOrderId;

/** Patch this book's line in the local cart, if it has one, and tell the header. */
export const patchCartLine = (bookId, patch) => {
  try {
    const raw = localStorage.getItem("selectedPlan");
    const cart = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(cart) || !cart.some((i) => i.bookId === bookId)) return;
    localStorage.setItem("selectedPlan", JSON.stringify(cart.map((i) => (i.bookId === bookId ? { ...i, ...patch } : i))));
    window.dispatchEvent(new Event("cartUpdated"));
  } catch {
    /* storage unavailable: the cart re-reads the book's format at checkout anyway */
  }
};

/**
 * Switch the book on the server, then in the stored book list. A PDF book has no
 * $5 add-on, so moving to PDF clears it on the cart line. Returns the API result.
 */
export const switchBookFormat = async (dispatch, bookId, format) => {
  const res = await setBookFormat(bookId, format);
  if (!res?.success) return res || { success: false };
  dispatch(updateBook({ _id: bookId, tag: format === "pdf" ? "downloadPdf" : null }));
  if (format === "pdf") patchCartLine(bookId, { includePdf: false });
  return res;
};
